import React, { Component } from "react";
import './BenchmarkLegend.css';

class BenchmarkLegend extends Component {
    render() {
        return(
            <div>
                <div className="evBenchmarkQualifier">Your answer compared to percentage breakdown of how Boards answered {this.props.questionText} in our 2020 Benchmarking.</div>
                <ul className="evBenchmarkLegend">
                    <li>Legend:</li>
                    <li className="unsure">Unsure</li>
                    <li className="no">No</li>
                    <li className="yesbut">Yes, But</li>
                    <li className="yes">Yes</li>
                </ul>
            </div>
        )
    }
}

export default BenchmarkLegend;